export const localStorageUserKey = "WatchTV_User";
